<template>
  <v-app>
    <div
      v-if="isOffline"
      class="animate__animated animate__slideInDown"
      style="
        position: fixed;
        z-index: 999;
        font-size: smaller;
        height: 25px;
        font-weight: bold;
        width: 100%;
        background: #d91e1e;
        padding: 3px;
        text-align: center;
        color: white;
      "
    >
      OFFLINE MODE
    </div>
    <component
      :is="currentLayout"
      v-if="isRouterLoaded"
    >
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view />
      </transition>
    </component>
    <v-snackbar
      color="#F2F5F8"
      elevation="24"
      style="z-index: 999; position: fixed"
      timeout="-1"
      id="arch-error"
      :absolute="true"
      v-model="info.visible"
      :vertical="true"
      top
    >
      <div
        v-if="typeof info.body === 'string'"
        style="text-align: center; margin-bottom: 5px"
      >
        <v-icon :color="info.textColor">
          {{ info.icon }}
        </v-icon>
      </div>
      <div
        :style="{ color : info.textColor }"
        v-if="typeof info.body === 'string'"
        class="error-container"
        v-html="info.body"
      />
      <arch-upload-report
        v-else-if="(typeof info.body === 'object' && info.body.tableTitle)"
        :error-message="info.body.errorMessage"
        :table-title="info.body.tableTitle"
        :headers="info.body.headers && info.body.headers.filter((el) => el.value !== 'actions')"
        :items="info.body.items"
        :icon="info.icon"
      />
      <template #action="{ attrs }">
        <v-btn
          :color="info.textColor"
          text
          v-bind="attrs"
          @click="showHideMessage(false)"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
      v-model="archConfirm.show"
      persistent
      max-width="400"
    >
      <v-card>
        <div style="text-align: center; padding: 10px">
          <v-icon
            size="30px"
            :color="archConfirmIcon.color"
          >
            {{
              archConfirmIcon.icon
            }}
          </v-icon>
        </div>
        <div
          class="headline"
          style="text-align: center"
        >
          {{ archConfirm.title }}
        </div>
        <v-card-text style="text-align: center">
          {{ archConfirm.message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="archConfirmCallback(false)">
            {{ archConfirm.no }}
          </v-btn>
          <v-btn
            :loading="archConfirm.closing"
            color="primary"
            @click="archConfirmCallback(true)"
          >
            {{ archConfirm.yes }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <NewVersionNotification
      v-model="updateNotificationVisible"
      @update-available="this.onUpdateAvailable"
    />
  </v-app>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import app from "@/store/app/index";
import config from "./configs";
import defaultLayout from "./layouts/DefaultLayout";
import simpleLayout from "./layouts/SimpleLayout";
import authLayout from "./layouts/AuthLayout";
import errorLayout from "./layouts/ErrorLayout";
import { Api } from "@/services/Api";
import worker from "@/workers/Index";
import NewVersionNotification from "sentec-vues/modules/service-worker/view/NewVersionNotification";
async function connectionCheck() {
  app.state.isOffline = !(await Api.isOnline());
  setTimeout(async () => {
    await connectionCheck();
  }, 20000);
}
export default {
  components: {
    NewVersionNotification,
    defaultLayout,
    simpleLayout,
    authLayout,
    errorLayout,
  },
  data() {
    return {
      updateNotificationVisible: false,
      sw_registration: null,
    };
  },
  created() {
    this.$setTitle(config.product.name);
  },
  computed: {
    ...mapState("app", [
      "toast",
      "info",
      "hotels",
      "archConfirm",
      "isOffline",
      "isSyncing",
    ]),
    isRouterLoaded: function () {
      return this.$route.name !== null;
    },
    currentLayout: function () {
      const layout = this.$route.meta.layout || "default";

      return layout + "Layout";
    },
    archConfirmIcon() {
      let temp = this.archConfirm.icons["info"];

      return this.archConfirm.icons[this.archConfirm.type] || temp;
    },
  },
  head: {
    link: [...config.icons.map((href) => ({ rel: "stylesheet", href }))],
  },
  methods: {
    ...mapMutations("app", ["archConfirmCallback", "showHideMessage"]),
    onUpdateAvailable() {
      this.updateNotificationVisible = true;
    },
  },
  async mounted() {
     app.state.window.width=window.innerWidth;
     app.state.window.height=window.innerHeight;
    await connectionCheck();
    window.addEventListener("offline", function (e) {
      app.state.isOffline = true;
    });
    window.addEventListener("online", function (e) {
      app.state.isOffline = false;
    });
    window.addEventListener("resize", e => {
      app.state.window.width=e.target.outerWidth;
      app.state.window.height=e.target.outerHeight;
    });
  },
  watch: {
    isOffline(newValue, oldValue) {
      if (!newValue && oldValue) {
        worker.Run();
      }
    },
    isSyncing(newValue) {
      if (newValue) {
        this.$archNotify({
          message: "Syncing pending requests!",
          color: "success",
        });
      }
    },
  },
};
</script>

<style>
#arch-error div div:nth-child(1) {
  width: 100% !important;
}
#nprogress .bar {
  background: #ec1721 !important;
}
#nprogress .spinner-icon {
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  border: solid 2px transparent;
  border-top-color: #ec1721 !important;
  border-left-color: #ec1721 !important;
}
#nprogress .spinner {
  top: 2px;
  right: 2px;
}
 .number-input input {
  text-align: end;
}

.container-light{
  margin: 0px;
  padding: 2px;
}

.container-header-button{
  margin: 0px;
  padding: 14px;
}

.error-container{text-align: center; color: rgb(156 15 27);max-height: 500px;overflow: auto;}
.message-container{text-align: center; color: rgb(40 143 54);max-height: 500px;overflow: auto;}
</style>
